import { DatePipe } from "@angular/common";
import { InformationFormatting } from "src/app/core/helpers/information-formatting/information-formatting";
import { ValidateData } from "../../utils/validate-data";

export class SolicitudAfiliacionObsoleta {
  static afiliacionDesdeObj(
    objAfiliado: object,
    objEmpresa: object,
    conyugeObj: object
  ) {
    let beneficiarios: Beneficiario[] = [];

    let trabajador: Trabajador = Trabajador.trabajadorDesdeObj(objAfiliado);

    let empleador: Empleador;
    if (objEmpresa) {
      empleador = Empleador.empleadorDesdeObj(objEmpresa);
    }

    let conyuge: Conyuge;
    if (conyugeObj) {
      conyuge = Conyuge.conyugeDesdeObj(conyugeObj);
    }

    return new SolicitudAfiliacionObsoleta(empleador, trabajador, conyuge, beneficiarios);
  }

  constructor(
    public empleador: Empleador,
    public trabajador: Trabajador,
    public conyuge: Conyuge,
    public beneficiarios: Beneficiario[]
  ) {}
}

export class Empleador {
  static empleadorDesdeObj(obj: object) {
    return new Empleador(
      // InformationFormatting.returnNameDocument(`${obj["tipoDocumento"]}`),
      `${obj["tipoDocumento"]}`,
      `${obj["numeroDocumento"]}`,
      `digito`,
      `${obj["correoElectronico"]}`
    );
  }

  constructor(
    public tipoIdEmpleador: string,
    public idEmpleador: string,
    public digVerifEmpleador: string,
    public correoEmpleador: string
  ) {}
}

export class Trabajador {
  static trabajadorDesdeObj(obj: object) {
    let horasMen = parseInt(`${obj["afiliacion"]["horasLaboradas"]}`) * 30;
  
    return new Trabajador(
      ``,
      InformationFormatting.returnNameDocument(`${obj["tipoDocumento"]}`),
      `${obj["numeroDocumento"]}`,
      `${obj["primerApellido"]}`,
      `${obj["segundoApellido"]}`,
      `${obj["primerNombre"]}`,
      `${obj["segundoNombre"]}`,
      `${obj["fechaNacimiento"]}`,
      `${obj["edad"]}`,
      `mail`,
      InformationFormatting.returnNameCivilStatus(`${obj["estadoCivil"]}`),
      InformationFormatting.returnNameGender(`${obj["genero"]}`),
      `${obj["afiliacion"]["fechaAfiliacion"]}`,
      `${obj["afiliacion"]["horasLaboradas"]}`,
      `${obj["afiliacion"]["salario"]}`,

      `${obj["direccion"]["direccionPrincipal"]}`,
      InformationFormatting.returnDepartment(
        `${obj["direccion"]["departamento"]["id"]}`
      ),
      InformationFormatting.returnNameCity(
        `${obj["direccion"]["ciudad"]["id"]}`.trim()
      ),
      `${obj["telefono"]}`,
      `Si`,
      `${obj["telefono"]}`,
      `${horasMen}`,
      InformationFormatting.returnNameSalaryType(
        `${obj["afiliacion"]["tipoSalario"]}`
      ),
      InformationFormatting.returnNameActivityType(
        `${obj["afiliacion"]["tipoCargo"]}`
      ),
      "Indefinido",
      "Colombia"
    );
  }
  constructor(
    public SucursalTrabajador: string,
    public TipoIdTrabajador: string,
    public NumIdTrabajador: string,
    public Apellido1Trabajador: string,
    public Apellido2Trabajador: string,
    public Nombre1Trabajador: string,
    public Nombre2Trabajador: string,
    public FechaNaciTrabajador: string,
    public EdadTrabajador: string,
    public EmailTrabajador: string,
    public EstadoCivilTrabajador: string,
    public GeneroTrabajador: string,
    public FechaIngresoTrabajador: string,
    public HorasLabDiaTrabajador: string,
    public SalarioTrabajador: string,
    public DireccionResTrabajador: string,
    public DepartamentoResTrabajador: string,
    public CiudadResTrabajador: string,
    public TelefonoResTrabajador: string,
    public AutEmailTrabajador: string,
    public TelefonoCelTrabajador: string,
    public HorasLabMesTrabajador: string,
    public TipSalarioTrabajador: string,
    public TipoActTrabajador: string,
    public TipoContraTrabajador: string,
    public NacionalidadTrabajador: string
  ) {}
}

export class Beneficiario {
  static beneficiarioDesdeObj(obj: object) {
    return new Beneficiario(
      InformationFormatting.returnNameDocument(`${obj["tipoDocumento"]}`),
      `${obj["numeroDocumento"]}`,
      `${obj["apellido"]}`.toLocaleUpperCase(),
      obj["segundoApellido"]
      ? `${obj["segundoApellido"]}`.toLocaleUpperCase()
      : "",
      `${obj["primerNombre"]}`.toLocaleUpperCase(),
      obj["segundoNombre"] ? `${obj["segundoNombre"]}`.toLocaleUpperCase() : "",
      InformationFormatting.returnNameGender(`${obj["genero"]}`),
      `${obj["fechaNacimiento"]}`,
      InformationFormatting.returnNameKinship(`${obj["parentescoPerCarg"]}`),
      InformationFormatting.returnDiscapacidad(`${obj["discapacidad"]}`)
    );
  }
  constructor(
    public TipoIdPerCarg: string,
    public NumIdPerCarg: string,
    public Apellido1PerCarg: string,
    public Apellido2PerCarg: string,
    public Nombre1PerCarg: string,
    public Nombre2PerCarg: string,
    public GeneroPerCarg: string,
    public FechaNaciPerCarg: string,
    public ParentescoPerCarg: string,
    public Discapacidad: string
  ) {}
}

export class Conyuge {
  static conyugeDesdeObj(obj: object) {
    let dateFormat = new DatePipe("en-US");
    return new Conyuge(
      InformationFormatting.returnNameDocument(`${obj["tipoDocumento"]}`),
      `${obj["numeroDocumento"]}`,
      `${obj["apellido"]}`,
      `${obj["segundoApellido"]}`,
      `${obj["primerNombre"]}`,
      `${obj["segundoNombre"]}`,
      InformationFormatting.returnNameGender(`${obj["genero"]}`),
      `${dateFormat.transform(obj["fechaNacimiento"], "yyyyMMdd")}`,

      `Hogar`,
      "",
      "",
      "",
      "",
      "",
      ""
    );
  }

  static conyugeDesdeObjConyuge(conyugeForm: any) {
    let dateFormat = new DatePipe("en-US");

    let TipoIdEmpresaConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? InformationFormatting.returnNameDocument(
          conyugeForm["TipoIdEmpresaConyuge"]
        )
      : "";
    let NumIdEmpresaConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? conyugeForm["NumIdEmpresaConyuge"]
      : "";
    let DigVerEmpresaConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? conyugeForm["DigVerEmpresaConyuge"]
      : "";
    let RazonEmpresaConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? conyugeForm["RazonEmpresaConyuge"]
      : "";
    let TipoSalarioConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? InformationFormatting.returnNameSalaryType(
          conyugeForm["TipoSalarioConyuge"]
        )
      : "";
    let SalarioConyuge = !ValidateData.emptyString(
      conyugeForm["TipoIdEmpresaConyuge"]
    )
      ? conyugeForm["SalarioConyuge"]
      : "";

    return new Conyuge(
      InformationFormatting.returnNameDocument(conyugeForm["TipoIdConyuge"]),
      conyugeForm["NumIdConyuge"],
      conyugeForm["Apellido1Conyuge"],
      conyugeForm["Apellido2Conyuge"],
      conyugeForm["Nombre1Conyuge"],
      conyugeForm["Nombre2Conyuge"],
      InformationFormatting.returnNameGender(conyugeForm["GeneroConyuge"]),
      dateFormat.transform(
        conyugeForm["FechaNaciConyuge"],
        "yyyyMMdd",
        "+0100"
      ),
      InformationFormatting.returnNameOccupattion(
        conyugeForm["OcupacionConyuge"]
      ),
      TipoIdEmpresaConyuge,
      NumIdEmpresaConyuge,
      DigVerEmpresaConyuge,
      RazonEmpresaConyuge,
      TipoSalarioConyuge,
      SalarioConyuge
    );
  }
  constructor(
    public TipoIdConyuge: string,
    public NumIdConyuge: string,
    public Apellido1Conyuge: string,
    public Apellido2Conyuge: string,
    public Nombre1Conyuge: string,
    public Nombre2Conyuge: string,
    public GeneroConyuge: string,
    public FechaNaciConyuge: string,
    public OcupacionConyuge: string,
    public TipoIdEmpresaConyuge: string,
    public NumIdEmpresaConyuge: string,
    public DigVerEmpresaConyuge: string,
    public RazonEmpresaConyuge: string,
    public TipoSalarioConyuge: string,
    public SalarioConyuge: string
  ) {}
}
